import {
  ADD_EMPLOYEE,
  ADD_EMPLOYEE_SUCCESS,
  ADD_EMPLOYEE_FAIL,
  GET_STAFF,
  GET_STAFF_SUCCESS,
  GET_STAFF_FAIL,
  DELETE_STAFF,
  DELETE_STAFF_FAIL,
  DELETE_STAFF_SUCCESS,
  GET_STAFF_BY_ID,
  GET_STAFF_BY_ID_SUCCESS,
  GET_STAFF_BY_ID_FAIL,
  UPDATE_EMPLOYEE,
  UPDATE_EMPLOYEE_FAIL,
  UPDATE_EMPLOYEE_SUCCESS,
  GET_STAFF_BY_EMAIL,
  GET_STAFF_BY_EMAIL_SUCCESS,
  GET_STAFF_BY_EMAIL_FAIL,
  GET_STAFF_CALENDER,
  GET_STAFF_CALENDER_FAIL,
  GET_STAFF_CALENDER_SUCCESS,
  POST_STAFF_DOC,
  POST_STAFF_DOC_FAIL,
  POST_STAFF_DOC_SUCCESS,
  STAFF_STATE,
  STAFF_STATE_SUCCESS,
  STAFF_STATE_FAIL,
  GET_EMPLOYEE_PROFILE_DOCS,
  GET_EMPLOYEE_PROFILE_DOCS_SUCCESS,
  GET_EMPLOYEE_PROFILE_DOCS_FAIL,
  APPROVE_EMP_DOCS,
  APPROVE_EMP_DOCS_SUCCESS,
  APPROVE_EMP_DOCS_FAIL,
  NOTIFY_EMPLOYEE,
  NOTIFY_EMPLOYEE_SUCCESS,
  NOTIFY_EMPLOYEE_FAIL,
  EMPLOYEES_EXPIRE_DOCS_LIST,
  EMPLOYEES_EXPIRE_DOCS_LIST_SUCCESS,
  EMPLOYEES_EXPIRE_DOCS_LIST_FAIL,
  AVAILABILITY,
  AVAILABILITY_SUCCESS,
  AVAILABILITY_FAIL,
  DELETE_STAFF_DOC,
  DELETE_STAFF_DOC_SUCCESS,
  DELETE_STAFF_DOC_FAIL,
  COPY_EMPLOYEE_PROFILE,
  COPY_EMPLOYEE_PROFILE_SUCCESS,
  COPY_EMPLOYEE_PROFILE_FAIL,
  GENERATE_TIME_SHEET,
  GENERATE_TIME_SHEET_SUCCESS,
  GENERATE_TIME_SHEET_FAIL,
  GET_ADMIN_TIMESHEET_LIST,
  GET_ADMIN_TIMESHEET_LIST_SUCCESS,
  GET_ADMIN_TIMESHEET_LIST_FAIL,
  SEND_TIME_SHEET_TO_SUPPORT_WORKER,
  SEND_TIME_SHEET_TO_SUPPORT_WORKER_SUCCESS,
  SEND_TIME_SHEET_TO_SUPPORT_WORKER_FAIL,
  RE_SUBMIT_TIME_SHEET,
  RE_SUBMIT_TIME_SHEET_SUCCESS,
  RE_SUBMIT_TIME_SHEET_FAIL,
  REMOVE_TIME_SHEET,
  REMOVE_TIME_SHEET_SUCCESS,
  REMOVE_TIME_SHEET_FAIL,
  APPROVE_EMP_VEHICLE_DOCS,
  APPROVE_EMP_VEHICLE_DOCS_SUCCESS,
  APPROVE_EMP_VEHICLE_DOCS_FAIL,
  GET_EMPLOYEE_RATING_REPORT,
  GET_EMPLOYEE_RATING_REPORT_SUCCESS,
  GET_EMPLOYEE_RATING_REPORT_FAIL,
  DELETE_TRAINING_DOC,
  DELETE_TRAINING_DOC_SUCCESS,
  DELETE_TRAINING_DOC_FAIL,
} from "./actionTypes";

export const employeeRatingReport = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_EMPLOYEE_RATING_REPORT,
  payload: { data, onSuccess, onError },
});

export const employeeRatingReportSuccess = data => ({
  type: GET_EMPLOYEE_RATING_REPORT_SUCCESS,
  payload: data,
});

export const employeeRatingReportFail = data => ({
  type: GET_EMPLOYEE_RATING_REPORT_FAIL,
  payload: data,
});

export const removeTimeSheet = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: REMOVE_TIME_SHEET,
  payload: { data, onSuccess, onError },
});

export const removeTimeSheetSuccess = data => ({
  type: REMOVE_TIME_SHEET_SUCCESS,
  payload: data,
});

export const removeTimeSheetFail = data => ({
  type: REMOVE_TIME_SHEET_FAIL,
  payload: data,
});

export const reSubmitTimeSheet = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: RE_SUBMIT_TIME_SHEET,
  payload: { data, onSuccess, onError },
});

export const reSubmitTimeSheetSuccess = data => ({
  type: RE_SUBMIT_TIME_SHEET_SUCCESS,
  payload: data,
});

export const reSubmitTimeSheetFail = data => ({
  type: RE_SUBMIT_TIME_SHEET_FAIL,
  payload: data,
});

export const sendTimeSheeToSupportWorker = (data, onSuccess = () => {}, onError = () => {}) => ({
  type: SEND_TIME_SHEET_TO_SUPPORT_WORKER,
  payload: { data, onSuccess, onError },
});
export const sendTimeSheeToSupportWorkerSuccess = data => ({
  type: SEND_TIME_SHEET_TO_SUPPORT_WORKER_SUCCESS,
  payload: data,
});
export const sendTimeSheeToSupportWorkerFail = data => ({
  type: SEND_TIME_SHEET_TO_SUPPORT_WORKER_FAIL,
  payload: data,
});

export const getAdminTimeSheetList = (data, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_ADMIN_TIMESHEET_LIST,
  payload: { data, onSuccess, onError },
});
export const getAdminTimeSheetListSuccess = data => ({
  type: GET_ADMIN_TIMESHEET_LIST_SUCCESS,
  payload: data,
});
export const getAdminTimeSheetListFail = data => ({
  type: GET_ADMIN_TIMESHEET_LIST_FAIL,
  payload: data,
});

export const generateTimeSheet = (data, onSuccess = () => {}, onError = () => {}) => ({
  type: GENERATE_TIME_SHEET,
  payload: { data, onSuccess, onError },
});
export const generateTimeSheetSuccess = data => ({
  type: GENERATE_TIME_SHEET_SUCCESS,
  payload: data,
});
export const generateTimeSheetFail = data => ({
  type: GENERATE_TIME_SHEET_FAIL,
  payload: data,
});

export const copyEmpProfile = (data, onSuccess = () => {}, onError = () => {}) => ({
  type: COPY_EMPLOYEE_PROFILE,
  payload: { data, onSuccess, onError },
});
export const copyEmpProfileSuccess = data => ({
  type: COPY_EMPLOYEE_PROFILE_SUCCESS,
  payload: data,
});
export const copyEmpProfileFail = data => ({
  type: COPY_EMPLOYEE_PROFILE_FAIL,
  payload: data,
});

export const deleteStaffDocument = (data, dispatch) => ({
  type: DELETE_STAFF_DOC,
  payload: { data, dispatch },
});
export const deleteStaffDocumentSuccess = data => ({
  type: DELETE_STAFF_DOC_SUCCESS,
  payload: data,
});
export const deleteStaffDocumentFail = data => ({
  type: DELETE_STAFF_DOC_FAIL,
  payload: data,
});

export const myAvailabilies = data => ({
  type: AVAILABILITY,
  payload: data,
});
export const myAvailabiliesSuccess = data => ({
  type: AVAILABILITY_SUCCESS,
  payload: data,
});
export const myAvailabiliesFail = data => ({
  type: AVAILABILITY_FAIL,
  payload: data,
});

export const getEmployeesExpDocs = data => ({
  type: EMPLOYEES_EXPIRE_DOCS_LIST,
  payload: data,
});
export const getEmployeesExpDocsSuccess = data => ({
  type: EMPLOYEES_EXPIRE_DOCS_LIST_SUCCESS,
  payload: data,
});
export const getEmployeesExpDocsFail = data => ({
  type: EMPLOYEES_EXPIRE_DOCS_LIST_FAIL,
  payload: data,
});

export const notifyEmployee = data => ({
  type: NOTIFY_EMPLOYEE,
  payload: data,
});
export const notifyEmployeeSuccess = data => ({
  type: NOTIFY_EMPLOYEE_SUCCESS,
  payload: data,
});
export const notifyEmployeeFail = data => ({
  type: NOTIFY_EMPLOYEE_FAIL,
  payload: data,
});

export const approveEmpDoc = data => ({
  type: APPROVE_EMP_DOCS,
  payload: data,
});
export const approveEmpDocSuccess = data => ({
  type: APPROVE_EMP_DOCS_SUCCESS,
  payload: data,
});
export const approveEmpDocFail = data => ({
  type: APPROVE_EMP_DOCS_FAIL,
  payload: data,
});

export const approveEmpVehicleDoc = (data, onSuccess = () => {}, onError = () => {}) => ({
  type: APPROVE_EMP_VEHICLE_DOCS,
  payload: { data, onSuccess, onError },
});
export const approveEmpVehicleDocSuccess = data => ({
  type: APPROVE_EMP_VEHICLE_DOCS_SUCCESS,
  payload: data,
});
export const approveEmpVehicleDocFail = data => ({
  type: APPROVE_EMP_VEHICLE_DOCS_FAIL,
  payload: data,
});

export const getEmpProfileDocs = data => ({
  type: GET_EMPLOYEE_PROFILE_DOCS,
  payload: data,
});
export const getEmpProfileDocsSuccess = data => ({
  type: GET_EMPLOYEE_PROFILE_DOCS_SUCCESS,
  payload: data,
});
export const getEmpProfileDocsFail = data => ({
  type: GET_EMPLOYEE_PROFILE_DOCS_FAIL,
  payload: data,
});

export const setStaffState = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: STAFF_STATE,
  payload: { data, onSuccess, onError },
});
export const StaffStateSuccess = data => ({
  type: STAFF_STATE_SUCCESS,
  payload: data,
});
export const StaffStateFail = data => ({
  type: STAFF_STATE_FAIL,
  payload: data,
});

export const postStaffdoc = data => ({
  type: POST_STAFF_DOC,
  payload: data,
});
export const postStaffdocSuccess = data => ({
  type: POST_STAFF_DOC_SUCCESS,
  payload: data,
});
export const postStaffdocFail = data => ({
  type: POST_STAFF_DOC_FAIL,
  payload: data,
});

export const getStaffCalData = data => ({
  type: GET_STAFF_CALENDER,
  payload: data,
});
export const getStaffCalDataSuccess = data => ({
  type: GET_STAFF_CALENDER_SUCCESS,
  payload: data,
});
export const getStaffCalDataFail = data => ({
  type: GET_STAFF_CALENDER_FAIL,
  payload: data,
});

export const getStaffByEmail = user => ({
  type: GET_STAFF_BY_EMAIL,
  payload: { user },
});

export const getStaffByEmailSuccess = data => ({
  type: GET_STAFF_BY_EMAIL_SUCCESS,
  payload: data,
});

export const getStaffByEmailFail = error => ({
  type: GET_STAFF_BY_EMAIL_FAIL,
  payload: error,
});

export const updateEmployee = (user, onSuccess = () => {}, onError = () => {}) => ({
  type: UPDATE_EMPLOYEE,
  payload: { user, onError, onSuccess },
});

export const updateEmployeeSuccess = data => ({
  type: UPDATE_EMPLOYEE_SUCCESS,
  payload: data,
});

export const updateEmployeeFail = error => ({
  type: UPDATE_EMPLOYEE_FAIL,
  payload: error,
});

export const addEmployee = (user, onSuccess = () => {}, onError = () => {}) => ({
  type: ADD_EMPLOYEE,
  payload: { user, onError, onSuccess },
});

export const addEmployeeSuccess = data => ({
  type: ADD_EMPLOYEE_SUCCESS,
  payload: data,
});

export const addEmployeeFail = error => ({
  type: ADD_EMPLOYEE_FAIL,
  payload: error,
});

export const getStaff = data => ({
  type: GET_STAFF,
  payload: data,
});

export const getStaffSuccess = data => ({
  type: GET_STAFF_SUCCESS,
  payload: data,
});

export const getStaffFail = error => ({
  type: GET_STAFF_FAIL,
  payload: error,
});

export const postDeleteStaff = id => ({
  type: DELETE_STAFF,
  payload: id,
});

export const postDeleteStaffSuccess = data => ({
  type: DELETE_STAFF_SUCCESS,
  payload: data,
});

export const postDeleteStaffFail = error => ({
  type: DELETE_STAFF_FAIL,
  payload: error,
});

export const getStaffDetail = id => ({
  type: GET_STAFF_BY_ID,
  payload: id,
});

export const getStaffDetailSuccess = data => ({
  type: GET_STAFF_BY_ID_SUCCESS,
  payload: data,
});

export const getStaffDetailFail = error => ({
  type: GET_STAFF_BY_ID_FAIL,
  payload: error,
});

export const deleteTrainingDoc = id => ({
  type: DELETE_TRAINING_DOC,
  payload: id,
});

export const deleteTrainingDocSuccess = data => ({
  type: DELETE_TRAINING_DOC_SUCCESS,
  payload: data,
});

export const deleteTrainingDocFailure = error => ({
  type: DELETE_TRAINING_DOC_FAIL,
  payload: error,
});
